import React from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import LayoutAdmin from 'components/Layout/Admin'
import PropertyFiltersContext from 'components/PropertyManagement/PropertyFiltersContext'
import { PER_PAGE } from 'components/PropertyManagement/config'

const DashboardContent = dynamic(() => import('components/DashboardContent'), {
  ssr: false,
})

const PropertyManagement = dynamic(() => import('components/PropertyManagement'), {
  ssr: false,
})

const PropertyManagementPage = props => {
  const router = useRouter()

  const filters = queryToFilters(router.query)

  const {
    url: { query, pathname }
  } = props

  return (
    <LayoutAdmin
      pageRoles={['BROKER']}
      urlData={{ query, pathname }}
      title="Gestión de propiedades"
    >
      <DashboardContent>
        <PropertyFiltersContext.Provider value={filters}>
          <PropertyManagement filters={filters} />
        </PropertyFiltersContext.Provider>
      </DashboardContent>
    </LayoutAdmin>
  )
}

const queryToFilters = query => {
  const {
    page,
    property_type,
    operation_type,
    search,
    status,
    price__amount__lte,
    price__amount__gte,
    created_at__gte,
    created_at__lte
  } = query

  const offset = page ? (parseInt(page) - 1) * PER_PAGE : 0
  const params = search
    ? { search }
    : {
        status,
        property_type,
        operation_type,
        price__amount__lte,
        price__amount__gte,
        created_at__gte,
        created_at__lte
      }

  const filters = {
    ...params,
    offset,
    limit: PER_PAGE
  }

  return filters
}

PropertyManagementPage.getInitialProps = context => {
  return {}
}

export default PropertyManagementPage
